import { render, staticRenderFns } from "./ErrorNSDisplay.vue?vue&type=template&id=67a2aa87&"
import script from "./ErrorNSDisplay.vue?vue&type=script&lang=js&"
export * from "./ErrorNSDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports